// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__M_Q1q","content":"GlobalSearch_content__2n0-X"};